import { Position } from "../../../createCampaign/components/coverPreviewArea/coverPreviewArea";
import lightOrDarkColor from "@check-light-or-dark/color";
import "./campaignCover.scss";

export default function CampaignCover(props: {
  url?: string;
  buttonPosition?: Position;
  buttonColor?: string;
  buttonText?: string;
  className?: string;
  fontFamily?: string;
  onSubmit?: () => void;
}) {
  return (
    <div
      className={`campaign-cover ${props.className}`}
      style={{
        backgroundImage: `url(${props.url})`,
        justifyContent:
          props.buttonPosition == Position.CENTER ? "center" : "flex-end",
      }}
    >
      <div
        className="campaign-button"
        style={{
          backgroundColor: props.buttonColor ?? "#ffffff",
          alignSelf:
            props.buttonPosition == Position.BOTTOM_RIGHT
              ? "flex-end"
              : "center",
          color:
            lightOrDarkColor(props.buttonColor ?? "") === "light"
              ? "black"
              : "white",
          fontFamily: props.fontFamily,
        }}
        onClick={props.onSubmit}
      >
        {props.buttonText ?? "Continue"}
      </div>
      <div style={{ height: "5vh" }} />
    </div>
  );
}
